import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';
import {listSerializations, getSerialization, listDataSpecs} from "../utils/utilsDataSpec";


import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 



class SelectSerialization extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectDataSpec: false,
            selectInterface: false,
            label: "Serialization",
            idSelected: "",
            idDataSpec: null,
            idInterface: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectDataSpec = getParam('selectDataSpec',this.props);
        StateChange.idDataSpec = getParam('idDataSpec', this.props);

        StateChange.idInterface = getParam('idInterface', this.props);

        StateChange.idSelected = getParam('value', this.props);
        StateChange.onChange = getParam('onChange', this.props);

        
        if (StateChange.selectDataSpec){
            this.loadDataSpecs();
        }

        if (StateChange.idDataSpec){
            this.loadSerializations({idDataSpec:StateChange.idDataSpec});
        }

        if (StateChange.idInterface){
            this.loadSerializations({idInterface:StateChange.idInterface});
        }

        if (StateChange.idSelected){
            this.loadSelectedSerialization(StateChange.idSelected);
        }

        this.setState(StateChange);
    }


    loadSelectedSerialization(idSerialization){

        if (!idSerialization){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Serialization) => {
            const StateChange = {
                SelectedSerialization: Serialization,
                renderState: "loaded"
            };
            

            if (!this.props.idInterface){
                if (Serialization.DataSpec){
                    StateChange.idDataSpec = Serialization.DataSpec._id;
                    this.loadSerializations({idDataSpec: StateChange.idDataSpec});
                }
           }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load DataSpec"
            });
        };

        getSerialization(this.dsd, idSerialization, onLoad, onFail);
        
    };


    loadDataSpecs() {

        this.setState({ renderState: 'loading' });

        const onLoad = (DataSpecs) => {
            this.setState({ DataSpecs, renderState: 'loaded' });
        };

        const onError = (error) => {
            this.setState({
                renderState: 'failed',
                errorMessage: error.message || 'Failed to load DataSpecs'
            });
        };

        listDataSpecs(this.dsd, {}, onLoad, onError);

    }


    loadSerializations(Filters={}){

        this.setState({renderState: "loading"});

        const onLoad = (Serializations) => {
            this.setState({
                Serializations: Serializations,
                renderState: "loaded"
            });

        };
        
        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load serializations"
            });
        };
    
        listSerializations(this.dsd, Filters, onLoad, onError);

    };




    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idDataSpec":
                this.setState({"idDataSpec":FormFieldValue});
                if (FormFieldValue){
                    this.loadSerializations({idDataSpec: FormFieldValue});
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };
        
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectDataSpec && this.state.DataSpecs &&
                            <PD.Select label="Data Spec" name="idDataSpec" onChange={this.handleChange} value={this.state.idDataSpec || ''}>
                                {
                                    this.state.DataSpecs.map(
                                        (DataSpec, pos) =>
                                            <option key={pos} value={DataSpec._id}>{DataSpec.name}</option>
                                    )
                                }
                            </PD.Select>
                        }

                        {this.state.Serializations &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Serializations.map(
                                        (Serialization, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Serialization._id}>{Serialization.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectSerialization_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectSerialization {...props} navigation={navigation} location={location} params={params} />;
  }
